import React, { useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import TrackingModal from "../components/TrackingModal";

const Tracking = () => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [trackingData, setTrackingData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTrackingNumberChange = (event) => {
    setTrackingNumber(event.target.value);
  };

  const handleTrackButtonClick = async () => {
    try {

      const cargoCollectionRef = collection(db, "cargo");
      const q = query(
        cargoCollectionRef,
        where("tracking_id", "==", trackingNumber)
      );
      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        console.log(`Tracking number ${trackingNumber} not found.`);
        setTrackingData(null);
      } else {
        const data = snapshot.docs[0].data();
        console.log('Tracking data:', data);
        setTrackingData(data);
      }
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching tracking data:", error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div style={{ position: "relative", width: "100%", overflow: "hidden" }}>
        <video
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          style={{ filter: "brightness(0.2)", zIndex: 1 }}
        >
          <source
            src={require("../assets/videos/banner.mp4")}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div
          className="tracking-form-container"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            textAlign: "center",
            zIndex: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '30px',
          }}
        >
          <p className="tracking-title" style={{color:'#fff'}}>Track Your Shipment</p>
          <p className="tracking-description" style={{color:'#fff'}}>
            To track your shipment, please enter your tracking number below,
            select the website, and click the "Track" button.
          </p>
          <div className="tracking-input" style={{color:'#fff'}}>
            <input
              type="text"
              value={trackingNumber}
              onChange={handleTrackingNumberChange}
              placeholder="Enter your tracking number"
              className="tracking-input-field p-2"
              style={{ color: '#000', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #ccc' }}
            />
            <button
              type="button"
              onClick={handleTrackButtonClick}
              className="tracking-button btn btn-info"
      style={{ marginLeft: '5px', fontSize: '16px', fontWeight: 'bolder' }}

            >
              TRACK
            </button>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <TrackingModal data={trackingData} closeModal={closeModal} />
      )}
    </>
  );
};

export default Tracking;
